import * as React from "react";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

interface Props {
  cert: string;
  name: string;
  url: string;
}

function ViewDetailsButton({ cert, url, name }: Props) {
  const navigate = useNavigate();
  return (
    <Button
      variant="contained"
      color="secondary"
      disableElevation
      aria-label={`View Details for ${name}.`}
      id={`view-details-button-${cert}`}
      className={"viewDetailsButton"}
      onClick={() =>
        navigate(
          {
            pathname: `/bankfind/details/${cert}`,
          },
          {
            state: {
              url: url,
            },
          },
        )
      }
    >
      View Details
    </Button>
  );
}

export default ViewDetailsButton;
